import { Reveal, SectionHeading } from "@/components/Reveal";
import { waMenuLink } from "@/data/site";

const categories = [
  {
    n: "01",
    title: "Primi piatti",
    desc: "Paste al forno, orecchiette, lasagne, risotti e ricette preparate secondo la disponibilità giornaliera.",
    items: ["Orecchiette al sugo", "Pasta al forno", "Lasagne", "Parmigiana di pasta", "Risotti", "Primi stagionali", "Specialità salentine"],
  },
  {
    n: "02",
    title: "Secondi piatti",
    desc: "Polpette, arrosti, carne al forno, pollo, specialità tradizionali e altre proposte del giorno.",
    items: ["Polpette al sugo", "Polpette fritte", "Arrosti", "Pollo al forno", "Involtini", "Carne alla pizzaiola", "Spezzatino", "Secondi del giorno"],
  },
  {
    n: "03",
    title: "Contorni",
    desc: "Verdure grigliate, patate al forno, parmigiana, verdure di stagione e preparazioni tipiche.",
    items: ["Parmigiana di melanzane", "Patate al forno", "Verdure grigliate", "Verdure gratinate", "Insalate", "Legumi", "Contorni stagionali"],
  },
  {
    n: "04",
    title: "Focacce e rustici",
    desc: "Focacce farcite, prodotti da forno, rustici e specialità ideali anche per buffet e aperitivi.",
    items: ["Focacce classiche", "Focacce farcite", "Rustici", "Torte salate", "Panzerotti", "Prodotti da forno del giorno"],
  },
  {
    n: "05",
    title: "Proposte fredde",
    desc: "Piatti freschi e leggeri, perfetti per l'estate e per chi cerca un'alternativa veloce.",
    items: ["Insalate di riso", "Paste fredde", "Insalate miste", "Piatti freschi stagionali"],
  },
  {
    n: "06",
    title: "Dolci",
    desc: "Il finale giusto per ogni pranzo, preparato secondo la giornata.",
    items: ["Dolci della casa", "Dessert monoporzione", "Specialità del giorno"],
  },
];

export default function MenuSection() {
  return (
    <section id="menu" className="py-24 md:py-32 lg:py-40 bg-sand/60">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Il menù di SAPORÉ"
          title={<>Cosa trovi <span className="italic text-terracotta">da noi</span></>}
        />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-charred/70 leading-relaxed">
            Ogni giorno prepariamo una selezione di piatti caldi e specialità d'asporto. Il menù può variare in base alla giornata, alla stagionalità e alla disponibilità degli ingredienti.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {categories.map((c, i) => (
            <Reveal key={c.n} delay={(i % 3) * 0.08}>
              <div className="group">
                <div className="flex items-baseline gap-4">
                  <span className="font-serif text-lg text-terracotta/60">{c.n}</span>
                  <h3 className="font-serif text-2xl md:text-3xl text-charred group-hover:text-terracotta transition-colors">{c.title}</h3>
                </div>
                <p className="mt-3 text-sm text-charred/60 leading-relaxed">{c.desc}</p>
                <ul className="mt-5 divide-y divide-charred/10 border-t border-b border-charred/10">
                  {c.items.map((item) => (
                    <li key={item} className="py-2.5 text-sm md:text-base text-charred/80 flex items-center justify-between">
                      {item}
                      <span className="w-1 h-1 rounded-full bg-terracotta/50" aria-hidden="true" />
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 border border-charred/15 rounded-lg p-8 md:p-10 bg-cream flex flex-col md:flex-row md:items-center gap-6 justify-between">
          <div>
            <h3 className="font-serif text-2xl md:text-3xl text-charred">Il nostro menù cambia ogni giorno</h3>
            <p className="mt-2 text-sm md:text-base text-charred/70 max-w-xl">
              Le preparazioni indicate sono alcuni esempi della nostra proposta: la disponibilità può cambiare durante la giornata. Contattaci per conoscere i piatti disponibili, i prezzi e prenotare il tuo ordine.
            </p>
          </div>
          <a
            href={waMenuLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-request-today-btn"
            className="shrink-0 rounded-full bg-terracotta text-cream px-7 py-3.5 text-sm font-semibold hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-300 text-center"
          >
            Richiedi il menù di oggi
          </a>
        </Reveal>
      </div>
    </section>
  );
}
